import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MetalColorForm from '../../../../components/masters/metalPurity/metalColor/MetalColorForm';
import MetalColorTable from '../../../../components/masters/metalPurity/metalColor/MetalColorTable';
import { fetchMetalColors, addMetalColor, updateMetalColor, deleteMetalColor, setMetalColorEdit, clearMetalColorEdit } from '../../../../redux/actions/masters/metalPurity/metalColor/metalColorAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .metal-color-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .metal-color-form, .metal-color-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const MetalColorPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingMetalColor, formSuccess, formError } = useSelector(state => state.metalColor || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchMetalColors());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearMetalColorEdit());
  };

  const handleSubmit = async (form) => {
    if (editingMetalColor && editingMetalColor.metal_color_id) {
      await dispatch(updateMetalColor(editingMetalColor.metal_color_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addMetalColor(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (metalColor) => {
    dispatch(setMetalColorEdit(metalColor));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteMetalColor(id));
  };

  const handleCancel = () => {
    dispatch(clearMetalColorEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      mc => mc.metal_color_code === code && (!excludeId || mc.metal_color_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="metal-color-flex">
        <div style={tableContainer} className="metal-color-table">
          <MetalColorTable
            onNew={handleFormReset}
            metalColors={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="metal-color-form">
          <MetalColorForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingMetalColor={editingMetalColor}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default MetalColorPage; 